<template>
  <span class="sub-label"><slot /></span>
</template>

<style>
  .secondary .sub-label {
    color: #d9b8ff;
  }

  .primary .sub-label {
    color: #8fe3f9;
  }
</style>
